import React, { useEffect, useState } from "react";
import styles from "./PasswordResetRequest.module.scss";
import TextForm, { TextFormResult } from "../../atoms/text-form/TextForm";
import SimpleButton from "../../atoms/simple-button/SimpleButton";
import { passwordReset } from "../../api/PasswordApi";
import { useNavigate } from "react-router-dom";
import Header from "../../molecules/header/Header";
import BreadCrumb from "../../molecules/breadcrumb/BreadCrumb";
import { atom, useAtom } from "jotai";
import { mailAtom } from "../../atoms/mail/Mail";

type Form = {
  emailAddress: string;
};

const PasswordResetRequest = () => {
  const navigator = useNavigate();
  const [formValue, setFormValue] = useState<Form>({
    emailAddress: "",
  });
  const [, setEmail] = useAtom(mailAtom);
  const passwordResetApi = passwordReset();
  const handleInputChange = (args: TextFormResult) => {
    setFormValue((prevValues) => ({ ...prevValues, [args.name]: args.value }));
  };

  // ボタン活性判定：未入力なら非活性
  const canSubmit = formValue.emailAddress.trim().length > 0;

  // メール送信中判定
  const isSubmitting = passwordResetApi.state?.status === "processing";

  const onClick = () => {
    // 二重送信ガード：送信中 or 未入力なら何もしない
    if (isSubmitting || !canSubmit) return;
    passwordResetApi.post({
      emailAddress: formValue.emailAddress,
    });
  };

  useEffect(() => {
    if (passwordResetApi.state?.status === "success") {
      setEmail(formValue.emailAddress);
      navigator("/password/reset-mail");
    }
  }, [passwordResetApi.state?.status]);

  // 画面表示時に状態をリセット
  useEffect(() => {
    passwordResetApi.reset?.();
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.mainContent}>
        <Header hideMenu={true} />
        <div className={styles.title}>パスワード再設定</div>
        <div className={styles.inputArea}>
          <div className={styles.input}>
            <TextForm
              name="emailAddress"
              value={formValue.emailAddress}
              color="white"
              label="メールアドレス"
              inputWidth="100%" 
              onChange={handleInputChange}
            ></TextForm>
          </div>
          <div className={styles.buttonArea}>
            <SimpleButton
              label={isSubmitting ? "送信中..." : "パスワード再設定メールを送信"}
              width="100%"
              isRadius={true}
              onClick={onClick}
              disabled={isSubmitting || !canSubmit}
            ></SimpleButton>
          </div>
        </div>
          <div className={styles.marginTop}> </div>
          <div className={styles.link} onClick={() => navigator("/login")}>
            ログイン画面に戻る
          </div>
      </div>
      <BreadCrumb
        data={[
          { displayName: "みらいいコンシェル"},
          { displayName: "パスワード再設定", url: "/login" },
        ]}
      />
    </div>
  );
};

export default PasswordResetRequest;
